import { render, staticRenderFns } from "./MessageDocument.vue?vue&type=template&id=81c8581e&scoped=true&"
import script from "./MessageDocument.vue?vue&type=script&lang=js&"
export * from "./MessageDocument.vue?vue&type=script&lang=js&"
import style0 from "./MessageDocument.vue?vue&type=style&index=0&id=81c8581e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c8581e",
  null
  
)

export default component.exports